var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { adoptedStyle, customElement, boolattribute } from '@mantou/gem/lib/decorators';
import { GemElement, html } from '@mantou/gem/lib/element';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { theme } from '../../lib/theme';
import '../loading';
const maskStyle = createCSSSheet(css `
  :host {
    position: absolute;
    z-index: ${theme.popupZIndex};
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mask {
    position: absolute;
    z-index: 0;
    inset: 0;
    background-color: rgba(0, 0, 0, calc(${theme.maskAlpha} / 2));
  }
`);
/**
 * @customElement dy-loadable-mask
 */
let DuoyunLoadableMaskElement = class DuoyunLoadableMaskElement extends GemElement {
    constructor() {
        super(...arguments);
        this.render = () => {
            return html `
      <div class="mask"></div>
      <dy-loading></dy-loading>
    `;
        };
    }
};
DuoyunLoadableMaskElement = __decorate([
    customElement('dy-loadable-mask'),
    adoptedStyle(maskStyle)
], DuoyunLoadableMaskElement);
export { DuoyunLoadableMaskElement };
const style = createCSSSheet(css `
  :host {
    display: block;
    position: relative;
    z-index: 1;
    overflow: hidden;
  }
`);
/**
 * @attr loading
 */
let DuoyunLoadableBaseElement = class DuoyunLoadableBaseElement extends GemElement {
    constructor(options) {
        super(options);
        const mask = new DuoyunLoadableMaskElement();
        this.effect(() => {
            this.internals.ariaBusy = String(this.loading);
            if (this.loading) {
                this.shadowRoot.append(mask);
            }
            else {
                mask.remove();
            }
        });
    }
};
__decorate([
    boolattribute
], DuoyunLoadableBaseElement.prototype, "loading", void 0);
DuoyunLoadableBaseElement = __decorate([
    adoptedStyle(style)
], DuoyunLoadableBaseElement);
export { DuoyunLoadableBaseElement };
//# sourceMappingURL=loadable.js.map